exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".infl-fe__style__popoverWrapper___dX3xE {\n  position: absolute;\n  padding-top: 16px;\n  z-index: 1001;\n}\n.infl-fe__style__arrow___2k-Ty {\n  position: absolute;\n  height: 13px;\n  transform: translate(-18px, -100%);\n  top: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"popoverWrapper": "infl-fe__style__popoverWrapper___dX3xE",
	"arrow": "infl-fe__style__arrow___2k-Ty"
};